import { render, staticRenderFns } from "./ApprovedDetailShangke.vue?vue&type=template&id=5083858d&scoped=true"
import script from "./ApprovedDetailShangke.vue?vue&type=script&lang=js"
export * from "./ApprovedDetailShangke.vue?vue&type=script&lang=js"
import style0 from "./ApprovedDetailShangke.vue?vue&type=style&index=0&id=5083858d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5083858d",
  null
  
)

export default component.exports